module.exports = __webpack_public_path__ + "img/menu_white.196a6da4.svg";